import axios from 'axios';
import Checkbox from 'components/CustomCheckbox/CustomCheckbox.jsx';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import auth from '../../../libCustom/auth';
import * as QuotationsActions from '../redux/QuotationsActions';

const options = [
  { value: 'Nacional', label: 'Nacional' },
  { value: 'Internacional', label: 'Internacional' },
];
let people = [];
for (let i = 0; i <= 100; i++) {
  people.push({ value: i, label: i });
}

class generalQuotation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsSelect: {
        users: [],
      },
    };
  }

  componentWillMount() {
    const franchiseId = auth.getCurrentUser().franchiseId;
    const params = {
      fields: {
        emailConfiguration: false,
        roles: false,
        firstName: true,
        lastName: true,
        id: true,
      },
      where: {
        franchiseId: franchiseId,
        isDeleted: { neq: true },
      },
    };
    this.getOptionsSelect(
      'users',
      process.env.REACT_APP_URL_API +
      '/api/users?filter=' +
      JSON.stringify(params),
      (option) => {
        return {
          label: option.firstName + ' ' + option.lastName,
          value: option.id,
          object: option,
        };
      }
    );
  }

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    var response = await axios.get(url);
    var options = [];
    response.data.map((option) => {
      options.push(optionCreateFunction(option));
    });

    options.sort((a, b) => {
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();
      return labelA.localeCompare(labelB);
    });

    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
    });
  };

  selectAssigned = (event) => {
    if (event !== null) {
      this.props.dispatch(
        QuotationsActions.onChange(['generalQuotation', 'userId'], event.value)
      );
      this.props.dispatch(
        QuotationsActions.onChange(
          ['generalQuotation', 'assignedTo'],
          event.value
        )
      );
      this.props.dispatch(
        QuotationsActions.onChange(
          ['generalQuotation', 'executive'],
          event.object
        )
      );
    } else {
      this.props.dispatch(
        QuotationsActions.onChange(['generalQuotation', 'userId'], '')
      );
      this.props.dispatch(
        QuotationsActions.onChange(['generalQuotation', 'assignedTo'], '')
      );
      this.props.dispatch(
        QuotationsActions.onChange(
          ['generalQuotation', 'executive'],
          event.object
        )
      );
    }
  };

  onChangeStatus = (event) => {
    this.props.dispatch(
      QuotationsActions.onChange(
        ['generalQuotation', 'followUp'],
        event.target.checked
      )
    );
  };

  render() {
    let { Quotations } = this.props;
    let { optionsSelect } = this.state;

    const statusQuotation = Quotations.generalQuotation.followUp;

    return (
      <div className={'general-quotation'}>
        <Row>
          <Col md={4}>
            <label
              className="checkbox-inline"
              style={{ marginTop: '6px', padding: 0 }}
            >
              <Checkbox
                style={{ color: '#000', fontWeight: 'bold' }}
                number="20"
                label="Cotización de grupo"
                checked={Quotations.generalQuotation.group}
                onChange={(event) =>
                  this.props.dispatch(
                    QuotationsActions.onChange(
                      ['generalQuotation', 'group'],
                      event.target.checked
                    )
                  )
                }
              />
            </label>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <label
              className="checkbox-inline"
              style={{ marginTop: '6px', padding: 0 }}
            >
              <Checkbox
                style={{ color: '#000', fontWeight: 'bold' }}
                number="99"
                label="Paquete"
                checked={Quotations.generalQuotation.isPackage}
                onChange={(event) =>
                  this.props.dispatch(
                    QuotationsActions.onChange(
                      ['generalQuotation', 'isPackage'],
                      event.target.checked
                    )
                  )
                }
              />
            </label>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <label
              className="checkbox-inline"
              style={{ marginTop: '6px', padding: 0 }}
            >
              <Checkbox
                style={{ color: '#000', fontWeight: 'bold' }}
                number="1000"
                label="Seguimiento"
                checked={statusQuotation}
                onChange={(event) => this.onChangeStatus(event)}
              />
            </label>
          </Col>
        </Row>
        <br />
        <div className="form-group">
          <label htmlFor="client">Asignado a</label>
          <Select
            placeholder="-- Seleccionar"
            name="userId"
            required
            value={Quotations.generalQuotation.userId}
            options={optionsSelect.users}
            onChange={(event) => {
              if (event) {
                this.selectAssigned(event);
              } else {
                this.selectAssigned('');
              }
            }}
          />
          <input
            style={{
              height: 1,
              padding: 0,
              margin: 0,
              border: 0,
              color: 'white',
            }}
            required={true}
            type="text"
            id="userIdHidden"
            value={Quotations.generalQuotation.userId}
            readOnly={true}
          />
        </div>
        <div className="form-group">
          <label htmlFor="validDate">Válido hasta</label>
          <input
            type="date"
            className="form-control"
            id="validDate"
            value={Quotations.generalQuotation.validDate}
            required={true}
            onChange={(event) =>
              this.props.dispatch(
                QuotationsActions.onChange(
                  ['generalQuotation', 'validDate'],
                  event.target.value
                )
              )
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="reference">Destino</label>
          <input
            type="text"
            className="form-control"
            id="destination"
            required={true}
            value={Quotations.generalQuotation.destination}
            onChange={(event) =>
              this.props.dispatch(
                QuotationsActions.onChange(
                  ['generalQuotation', 'destination'],
                  event.target.value
                )
              )
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="reference">Interés</label>
          <Select
            placeholder="-- Seleccionar"
            name="userId"
            required={true}
            value={Quotations.generalQuotation.interest}
            options={options}
            onChange={(event) => {
              if (event) {
                this.props.dispatch(
                  QuotationsActions.onChange(
                    ['generalQuotation', 'interest'],
                    event.value
                  )
                );
              } else {
                this.props.dispatch(
                  QuotationsActions.onChange(
                    ['generalQuotation', 'interest'],
                    ''
                  )
                );
              }
            }}
          />
        </div>
        <Row>
          <Col md={4}>
            <div className="form-group">
              <label htmlFor="reference">Adultos (Mayor a 18 años)</label>
              <Select
                placeholder="-- Seleccionar"
                name="adults"
                value={Quotations.generalQuotation.adults}
                options={people}
                onChange={(event) => {
                  if (event) {
                    this.props.dispatch(
                      QuotationsActions.onChange(
                        ['generalQuotation', 'adults'],
                        event.value
                      )
                    );
                  } else {
                    this.props.dispatch(
                      QuotationsActions.onChange(
                        ['generalQuotation', 'adults'],
                        ''
                      )
                    );
                  }
                }}
              />
            </div>
          </Col>
          <Col md={4}>
            <div className="form-group">
              <label htmlFor="reference">Juniors (13-17 años)</label>
              <Select
                placeholder="-- Seleccionar"
                name="juniors"
                value={Quotations.generalQuotation.juniors}
                options={people}
                onChange={(event) => {
                  if (event) {
                    this.props.dispatch(
                      QuotationsActions.onChange(
                        ['generalQuotation', 'juniors'],
                        event.value
                      )
                    );
                  } else {
                    this.props.dispatch(
                      QuotationsActions.onChange(
                        ['generalQuotation', 'juniors'],
                        ''
                      )
                    );
                  }
                }}
              />
            </div>
          </Col>
          <Col md={4}>
            <div className="form-group">
              <label htmlFor="reference">Niños (0-12 años)</label>
              <Select
                placeholder="-- Seleccionar"
                name="kids"
                value={Quotations.generalQuotation.kids}
                options={people}
                onChange={(event) => {
                  if (event) {
                    this.props.dispatch(
                      QuotationsActions.onChange(
                        ['generalQuotation', 'kids'],
                        event.value
                      )
                    );
                  } else {
                    this.props.dispatch(
                      QuotationsActions.onChange(
                        ['generalQuotation', 'kids'],
                        ''
                      )
                    );
                  }
                }}
              />
            </div>
          </Col>
        </Row>{' '}
        <div className="form-group">
          <label htmlFor="reference">
            Observaciones del cliente acerca de la cotización
          </label>
          <textarea
            type="text"
            className="form-control"
            id="notes"
            value={Quotations.generalQuotation.notes}
            onChange={(event) =>
              this.props.dispatch(
                QuotationsActions.onChange(
                  ['generalQuotation', 'notes'],
                  event.target.value
                )
              )
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="trackingLine">Línea de Seguimiento</label>
          <textarea
            type="text"
            className="form-control"
            id="trackingNotes"
            value={Quotations.generalQuotation.trackingLine}
            onChange={(event) =>
              this.props.dispatch(
                QuotationsActions.onChange(
                  ['generalQuotation', 'trackingLine'],
                  event.target.value
                )
              )
            }
          />
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ Quotations: state.Quotations }))(
  generalQuotation
);



// WEBPACK FOOTER //
// ./src/views/Quotations/cards/generalQuotation.js